module.exports = __webpack_public_path__ + "static/img/Random.877a4413.svg";